import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { InvoiceModal } from './InvoiceModal';
import { Invoices } from './Invoices';
import { api } from 'services';
import { registerLocale } from 'react-datepicker';
import BR from 'date-fns/locale/pt-BR';
import { toast } from 'react-toastify';
import { currencyReverse } from 'helpers/Currency';
import { formatDate } from 'helpers/date';
import { connect } from 'react-redux';
import { LOADING } from 'store';

registerLocale('BR', BR);

const ActionsFormInvoices = ({
  loading,
  actionId,
  actionName,
  invoices,
  editable,
  setInvoices,
  action_
}) => {
  const [showModal, setShowModal] = useState(false);
  const [dueDate, setDueDate] = useState('');
  const [value, setValue] = useState('');
  const [currency, setCurrency] = useState('');
  const [isInvoice, setIsInvoice] = useState(false);
  const [hidden, setHidden] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [currencies, setCurrencies] = useState([]);
  const [number, setNumber] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [terms, setTerms] = useState('');
  const [stateRegistration, setStateRegistration] = useState('');
  const [error, setError] = useState(false);

  const [description, setDescription] = useState('');

  const { t } = useTranslation();

  // useEffect(()=>{
  //   setDescription(actionName);
  // },[actionName]);

  const handleHideModal = () => {
    setShowModal(false);
    setDueDate('');
    setValue('');
    setIsInvoice(false);
    setNumber('');
    setPostalCode('');
    setTerms('');
    setStateRegistration('');
    setCurrency('');
    setError(false);
  };

  useEffect(() => {
      api.get('currencies').then(({ data }) => setCurrencies(data));
  }, []);

  const handleSave = () => {
    setIsLoading(true);
    setError(false);
    const formData = new FormData();
    
    formData.append('currency_id', currency);
    formData.append('action_id', actionId);
    formData.append('due_date', formatDate(dueDate));
    formData.append('value', currencyReverse(value));
    formData.append('invoice', isInvoice ? 1 : 0);
    formData.append('currency_id', currency ? currency : 1);
    formData.append('number', number);
    formData.append('description', description);
    formData.append('terms', terms);
    formData.append('postal_code', postalCode.replace("-", ""));
    formData.append('state_registration', stateRegistration.replace("-", ""));
    api
      .post('invoice', formData, {
        headers: {
          'X-Success-Message': `${isInvoice ? 'Invoice adicionada com sucesso' : 'Nota de Débito adicionada com sucesso'}`,
          'X-Show-Alert': true
        }
      })
      .then((response) => {
        handleHideModal();
        refreshInvoices();
      })
      .catch((error) => setError(true))
      .finally(() => {
        loading(false);
        setIsLoading(false);
      });
  };

  const refreshInvoices = async () => {
    api.get('invoice/' + actionId).then((response) => {
      setInvoices(response.data);
    });
  };

  if (!actionId) return <React.Fragment />;
  return (
    <React.Fragment>
      <InvoiceModal
        showModal={showModal}
        handleHideModal={handleHideModal}
        t={t}
        currency={currency}
        setCurrency={setCurrency}
        isInvoice={isInvoice}
        value={value}
        setValue={setValue}
        dueDate={dueDate}
        setDueDate={setDueDate}
        isLoading={isLoading}
        handleSave={handleSave}
        currencies={currencies}
        number={number}
        postalCode={postalCode}
        terms={terms}
        stateRegistration={stateRegistration}
        setNumber={setNumber}
        setPostalCode={setPostalCode}
        setTerms={setTerms}
        setStateRegistration={setStateRegistration}
        error={error}
        description={description} 
        setDescription={setDescription}
        actionName={actionName}
      />

      <Invoices
        t={t}
        invoices={invoices}
        setHidden={setHidden}
        setShowModal={setShowModal}
        setIsInvoice={setIsInvoice}
        editable={editable}
        hidden={hidden}
        setCurrency={setCurrency}
      />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  loading: (payload) => dispatch({ type: LOADING, payload }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ActionsFormInvoices);
